'use strict'
const renderDoneMixin = require('./core/renderDoneMixin')
const htmlParser = require('./core/htmlParser')
const htmlTransformer = require('./core/htmlTransformer')
const textSecurityFixer = require('./core/textSecurityFixer')
const throttleUtils = require('./core/throttleUtils')
const keyboardUtils = require('./core/keyboardUtils')
const classNames = require('./core/classNames')
const cookieUtils = require('./core/cookieUtils')
const tween = require('./core/tween')
const urlUtils = require('./core/urlUtils')
const store = require('./core/store2')
const storeNew = require('./core/store2_new')
const mobileViewportFixer = require('./core/mobileViewportFixer')
const dataUtils = require('./core/dataUtils')
const dateTimeUtils = require('./core/dateTimeUtils')
const validationUtils = require('./core/validationUtils')
const cssUtils = require('./core/cssUtils')
const hashUtils = require('./core/hashUtils')
const guidUtils = require('./core/guidUtils')
const arrayUtils = require('./core/arrayUtils')
const stringUtils = require('./core/stringUtils')
const mediaZoomCalculations = require('./core/mediaZoomCalculations')
const objectUtils = require('./core/objectUtils')
const animationFrame = require('./core/animationFrame')
const domMeasurements = require('./core/domMeasurements')
const scrollUtils = require('./core/scrollUtils')
const storage = require('./core/storage')
const style = require('./core/style')
const verticalMenuCalculations = require('./core/verticalMenuCalculations')
const galleriesCommonLayout = require('./core/galleriesCommonLayout')
const requestsUtil = require('./core/requestsUtil')
const boundingLayout = require('./core/boundingLayout')
const nonPageItemZoom = require('./core/nonPageItemZoom')
const reactComponentUtils = require('./core/reactComponentUtils')
const appPartMediaInnerViewNameUtils = require('./core/appPartMediaInnerViewNameUtils')
const dockUtils = require('./core/dockUtils')
const viewportUtils = require('./core/viewportUtils')
const containerBackgroundUtils = require('./core/containerBackgroundUtils')
const math = require('./core/math')
const functionUtils = require('./core/functionUtils')
const mediaConsts = require('./core/mediaConsts')
const blogAppPartNames = require('./core/blogAppPartNames')
const siteConstants = require('./core/siteConstants')
const textPatternRecognizer = require('./core/textPatternRecognizer')
const errorPages = require('./core/errorPages')
const {logWixCodeConsoleMessage, logWixCodeConsoleError} = require('./core/logWixCodeConsoleMessage')
const matrixCalculations = require('./core/matrixCalculations')
const matrixScalingCalculations = require('./core/matrixScalingCalculations')
const timersMixins = require('./core/timersMixins')
const timeUtils = require('./core/timeUtils')
const browserDetection = require('./core/browserDetection')
const svgFilters = require('./core/svgFilters/svgFilters')
const fragment = require('./core/fragment')
const dynamicPagesUtils = require('./core/dynamicPagesUtils')
const log = require('./core/log')
const createFontUtils = require('./fonts/fontUtils')
const fonts = require('./fonts/fonts')
const tweenEngine = require('./tweenEngine/tweenEngine')
const SimpleDrag = require('./core/simpleDrag')
const Screenfull = require('./core/screenfullFork')


/**
 * @exports coreUtils
 */
module.exports = {
    log,
    renderDoneMixin,
    htmlTransformer,
    textSecurityFixer,
    htmlParser,
    throttleUtils,
    keyboardUtils,
    classNames,
    cookieUtils,
    tween,
    urlUtils,
    Store: store,
    StoreNew: storeNew,
    mobileViewportFixer,
    dataUtils,
    dateTimeUtils,
    validationUtils,
    cssUtils,
    hashUtils,
    guidUtils,
    arrayUtils,
    stringUtils,
    mediaZoomCalculations,
    objectUtils,
    animationFrame,
    domMeasurements,
    scrollUtils,
    storage,
    style,
    galleriesCommonLayout,
    requestsUtil,
    boundingLayout,
    verticalMenuCalculations,
    nonPageItemZoom,
    appPartMediaInnerViewNameUtils,
    reactComponentUtils,
    dockUtils,
    viewportUtils,
    containerBackgroundUtils,
    math,
    functionUtils,
    mediaConsts,
    balataConsts: mediaConsts.balataConsts,
    blogAppPartNames,
    siteConstants,
    textPatternRecognizer,
    errorPages,
    logWixCodeConsoleMessage,
    logWixCodeConsoleError,
    matrix: {
        calculations: matrixCalculations,
        scalingCalculations: matrixScalingCalculations
    },
    timersMixins,
    timeUtils,
    browserDetection,
    svgFilters,
    fragment,
    dynamicPagesUtils,
    createFontUtils,
    fonts,
    tweenEngine,
    SimpleDrag,
    Screenfull
}




// WEBPACK FOOTER //
// ./src/coreUtils/src/main/coreUtils.js